import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	hasError: boolean
	shouldFill?: boolean
	shouldShrink?: boolean
}

export const InputComponent = styled.input<Props>`
	background-color: transparent;
	border: none;
	color: currentColor;
	font-family: ${({ theme }) => theme.font.family.base};
	font-size: ${helpers.font.size.base};
	-webkit-tap-highlight-color: transparent;
	display: block;
	width: ${({ shouldFill = true, shouldShrink = false }) => {
		if (shouldShrink) return '5px' // It will still render the caret at this size
		return shouldFill ? '100%' : 'max-content'
	}};
	min-height: 20px;
	height: 20px;

	&:focus {
		outline: none;
	}

	&::placeholder {
		color: ${({ hasError, theme }) => (hasError ? theme.color.input.placeholderError : theme.color.input.placeholder)};
	}
`
